import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { getPhysiotherapyRequestComments } from '../../../services/api/cashless-physiotherapy-v2';
import LoadingComponent from '../../common/LoadingComponent';
import CommentList from '../../offline-consultations/comments/commentList';
import CommentForm from '../components/CommentForm';

const PhysiotherapyCommentModal = ({
    isOpen,
    onClose,
    requestId,
    onComplete,
    className = 'bg-info'
}) => {

    const [comments, setComments] = useState([])

    useEffect(() => {
        if (!requestId) {
            return
        }
        getPhysiotherapyRequestComments(requestId)
            .then((response) => {
                if (response && response.comments) {
                    setComments(response.comments.map(c => ({
                        name: c.userName,
                        message: c.content,
                        time: c.createdAt
                    })))
                }
            }).catch((err) => {
                console.error('Error fetching comments:', err);
                setComments([])
            })
    }, [requestId])

    const addNewComment = (newComment) => {
        setComments(c => ([...c, newComment]))
        onComplete()
    }

    return <Modal isOpen={isOpen} toggle={onClose} size="lg">
        {!comments ?
            <LoadingComponent color={'black'} /> :
            <>
                <ModalHeader className={className} toggle={onClose}>
                    Comments (Request Id: {requestId})
                </ModalHeader>
                <ModalBody>
                    {/* Fixed heading with count */}
                    <h5 className="text-muted mb-3 bold">
                        <span className="badge badge-success">{comments.length}</span>{" "}
                        Comment{comments.length !== 1 ? "s" : ""}
                    </h5>

                    {/* Scrollable comments section - expands for first 2 comments */}
                    <div style={{
                        maxHeight: comments.length > 2 ? '200px' : 'auto',
                        overflowY: comments.length > 2 ? 'auto' : 'visible',
                        marginBottom: '20px',
                        paddingRight: '10px'
                    }}>
                        {comments.length === 0 ? (
                            <div className="alert text-center alert-info">
                                Comment History Empty
                            </div>
                        ) : (
                            comments.map((comment, index) => (
                                <div key={index} style={{
                                    padding: '10px',
                                    marginBottom: '10px',
                                    borderBottom: '1px solid #eee'
                                }}>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        marginBottom: '5px'
                                    }}>
                                        <span style={{ fontWeight: 'bold' }}>
                                            {comment.name}
                                        </span>
                                        <span style={{
                                            fontSize: '0.85em',
                                            color: '#888'
                                        }}>
                                            {comment.time}
                                        </span>
                                    </div>
                                    <div style={{ color: '#333' }}>
                                        {comment.message}
                                    </div>
                                </div>
                            ))
                        )}
                    </div>

                    {/* Fixed comment form */}
                    <div>
                        <CommentForm
                            addComment={addNewComment}
                            requestId={requestId}
                            commentType={'internal'}
                        />
                    </div>
                </ModalBody>
            </>
        }
    </Modal>
}

export default PhysiotherapyCommentModal